import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import logo from '../assets/images/camdiab-logo.png';
import mobile_logo from '../assets/images/mobile-logo.svg';
import {headerText as headerText_en} from "../libs/en/texts-header-lib";
import parse from "html-react-parser";
import {queueAnalyticsInit} from '../utils/analytics';
import {loadLocaleExport} from '../utils/localeLoader';
import {getLanguagePrefix} from '../utils/language';
import {getNavCountryDisplay, isCamAPSLibertyVisible, setCountryReturnPath} from '../utils/countries';

export class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: this.props.props.language,
            clickedOutside: false,
            faq: false,
            support: false,
            history: false,
            about: false,
            isCookie: (localStorage.getItem('camdiab-cookie-flag') === "true") || false,
            isCookieDenied: (localStorage.getItem('camdiab-cookie-denied') === "true") || false,
            headerText: headerText_en,
            isLanguageChanging: false,
        };
    }

    loadHeaderText = async (language) => {
        const headerText = await loadLocaleExport({
            language,
            fileName: 'texts-header-lib',
            exportName: 'headerText',
            folderOverrides: {'FR-FR': 'fr'},
        });

        if (this.props.props.language === language) {
            this.setState({language, headerText});
        }
    };

    componentDidMount() {
        this.loadHeaderText(this.props.props.language).catch(() => {
        });

        if (localStorage.getItem('camdiab-cookie-flag') === "true") {
            this.setState({isCookie: true})
        } else {
            localStorage.setItem('camdiab-cookie-denied', "true")
        }

        if (localStorage.getItem('camdiab-cookie-denied') === "true") {
            this.setState({isCookieDenied: true})
        }
        document.body.classList.remove('open-language');
        setTimeout(function () {
            document.body.classList.remove('open-toggle');
        }, 10);
        // const el = document.querySelector('.menu-icon');
        // el.onclick = () => {
        // 	document.body.classList.toggle('open-toggle');
        // };
        // Get the Link Class//

        document
            .querySelectorAll('.site-navigation nav ul li a')
            .forEach((item, index) => {
                //console.log(item.textContent);
                item.parentNode.classList.remove('active');
                if (item.getAttribute('href') === window.location.pathname) {
                    item.parentNode.classList.add('active');
                }
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.props.language !== this.props.props.language) {
            this.loadHeaderText(this.props.props.language).catch(() => {
            });
        }
    }

    removeToogling = () => {
        setTimeout(() => {
            document.body.classList.remove('open-toggle');
        }, 10);
        this.setState({about: false});
    };

    toggleSubmenu = (e) => {
        if (window.innerWidth >= 992) return;
        const li = e.currentTarget.closest('li');
        if (li) {
            li.classList.toggle('is-active');
        }
    };

    handleClickInside = () => {
        this.setState({clickedOutside: false});
    };

    getLanguagePrefix = () => {
        return getLanguagePrefix(this.props.props.language);
    };

    openCountryLanguagePage = () => {
        const pathname = (this.props.props.location && this.props.props.location.pathname)
            || window.location.pathname;
        setCountryReturnPath(pathname);
    };

    render() {
        const countryDisplay = getNavCountryDisplay(this.props.props.language);

        return (
            <div>
                <header className='header-main'> {
                    !this.state.isCookie &&
                    <div className="header-top-bar">
                        <div className="container">

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <p>{parse(this.state.headerText.cookiesIntroText)}</p>
                                    <p><a href="/#" title="Accept cookies" onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({isCookie: true}, () => {
                                            localStorage.setItem('camdiab-cookie-flag', "true");
                                            localStorage.setItem('camdiab-cookie-denied', "false");
                                            queueAnalyticsInit();
                                        })
                                    }}>{parse(this.state.headerText.cookiesAccept)}</a>
                                        <a href="/#" title="Decline cookies" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({isCookie: true}, () => {
                                                localStorage.setItem('camdiab-cookie-flag', "true");
                                                localStorage.setItem('camdiab-cookie-denied', "true")
                                            })
                                        }}>{parse(this.state.headerText.cookiesDeny)}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                    <div className='container-fluid'>
                        <div className='row align-items-center'>
                            <div className='col-12 col-sm-12 header-wrap'>
                                <div className='logo'>
                                    <NavLink to={this.getLanguagePrefix() + '/'}>
                                        <img src={logo} className='App-logo' alt='logo'/>
                                        <img src={mobile_logo} className='mobile-logo' alt='logo'/>
                                    </NavLink>
                                </div>
                                <div className='header-navigation'>
                                    <div
                                        className='menu-icon'
                                        onClick={() =>
                                            document.body.classList.toggle('open-toggle')
                                        }>
                                        <span>
                                        </span>
                                        <span>
                                        </span>
                                        <span>
                                        </span>
                                    </div>
                                    <div className='navigation-wrap'>
                                        <div className='site-navigation'>
                                            <nav>
                                                <ul>
                                                    <li onClick={(e) => this.removeToogling()}>
                                                        <NavLink to={this.getLanguagePrefix() + '/faq'}
                                                                 activeClassName='active'>
                                                            {parse(this.state.headerText.tabFAQs)}
                                                        </NavLink>
                                                    </li>
                                                    <li onClick={(e) => this.removeToogling()}>
                                                        <NavLink to={this.getLanguagePrefix() + '/support'}
                                                                 activeClassName='active'>
                                                            {parse(this.state.headerText.tabSupport)}
                                                        </NavLink>
                                                    </li>
                                                    <li onClick={(e) => this.removeToogling()}>
                                                        <NavLink to={this.getLanguagePrefix() + '/notifications'}
                                                                 activeClassName='active'>
                                                            {parse(this.state.headerText.tabNotifications)}
                                                        </NavLink>
                                                    </li>
                                                    <li className='has-dropdown'>
                                                        <span onClick={this.toggleSubmenu}>{parse(this.state.headerText.tabTraining)}</span>
                                                        <ul>
                                                            <li onClick={(e) => this.removeToogling()}>
                                                                <NavLink to={this.getLanguagePrefix() + '/user-training'}
                                                                         activeClassName='active'>
                                                                    {parse(this.state.headerText.tabUserTraining)}
                                                                </NavLink>
                                                            </li>
                                                            <li onClick={(e) => this.removeToogling()}>
                                                                <NavLink to={this.getLanguagePrefix() + '/traininghcp'}
                                                                         activeClassName='active'>
                                                                    {parse(this.state.headerText.tabHcpTraining)}
                                                                </NavLink>
                                                            </li>
                                                            {isCamAPSLibertyVisible(this.props.props.language) && (
                                                                <li onClick={(e) => this.removeToogling()}>
                                                                    <NavLink to={this.getLanguagePrefix() + '/liberty'}
                                                                             activeClassName='active'>
                                                                        {parse(this.state.headerText.tabCamAPSLiberty)}
                                                                    </NavLink>
                                                                </li>
                                                            )}
                                                            <li onClick={(e) => this.removeToogling()}>
                                                                <NavLink to={this.getLanguagePrefix() + '/pregnancy'}
                                                                         activeClassName='active'>
                                                                    {parse(this.state.headerText.tabPregnancy)}
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li className='has-dropdown'>
                                                        <span onClick={this.toggleSubmenu}>{parse(this.state.headerText.tabAbout)}</span>
                                                        <ul>
                                                            <li onClick={(e) => this.removeToogling()}>
                                                                <NavLink to={this.getLanguagePrefix() + '/history'}
                                                                         activeClassName='active'>
                                                                    {parse(this.state.headerText.tabHistory)}
                                                                </NavLink>
                                                            </li>
                                                            {(this.props.props.language !== "FR-FR") &&
                                                                <li onClick={(e) => this.removeToogling()}>
                                                                    <NavLink to={this.getLanguagePrefix() + '/stories'}
                                                                             activeClassName='active'>
                                                                        {parse(this.state.headerText.tabReviews)}
                                                                    </NavLink>
                                                                </li>}
                                                        </ul>
                                                    </li>
                                                    <li onClick={(e) => this.removeToogling()}>
                                                        <NavLink to={this.getLanguagePrefix() + '/press-releases'}
                                                                 activeClassName='active'>
                                                            {parse(this.state.headerText.tabNews)}
                                                        </NavLink>
                                                    </li>
                                                    {this.props.props.language === 'EN' && (
                                                    <li onClick={(e) => this.removeToogling()}>
                                                        <NavLink to={this.getLanguagePrefix() + '/careers'}
                                                                 activeClassName='active'>
                                                            {parse(this.state.headerText.tabCareers)}
                                                        </NavLink>
                                                    </li>
                                                    )}
                                                </ul>
                                            </nav>
                                        </div>
                                        <NavLink
                                            className="country-nav-link"
                                            to={this.getLanguagePrefix() + '/language'}
                                            onClick={this.openCountryLanguagePage}
                                            title="Choose your country and language"
                                        >
                                            <img
                                                className="country-nav-flag"
                                                src={`https://flagcdn.com/w40/${countryDisplay.code.toLowerCase()}.png`}
                                                srcSet={`https://flagcdn.com/w20/${countryDisplay.code.toLowerCase()}.png 1x, https://flagcdn.com/w40/${countryDisplay.code.toLowerCase()}.png 2x`}
                                                width="20"
                                                height="15"
                                                alt=""
                                            />
                                            <span className="country-nav-code">{countryDisplay.code}</span>
                                        </NavLink>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}


